import React from 'react';
import { Modal, Form, Input } from 'antd';
import { useCreateUser } from '../../hooks/useCreateUser';

export interface AddUserModalProps {
  open: boolean;
  onClose: () => void;
  onSuccess?: () => void;
}

const PASSWORD_MIN_LENGTH = 6;

export function AddUserModal({ open, onClose, onSuccess }: AddUserModalProps) {
  const [form] = Form.useForm();
  const createUser = useCreateUser({
    onSuccess: () => {
      onClose();
      form.resetFields();
      onSuccess?.();
    },
  });

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      await createUser.mutateAsync({
        name: values.name?.trim() || '',
        phone: values.phone?.trim() || '',
        email: values.email?.trim() || undefined,
        password: values.password,
        address: values.address?.trim() || undefined,
      });
    } catch {
      // Validation errors or API errors handled by hook
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      title="Add User"
      open={open}
      onOk={handleSubmit}
      onCancel={handleCancel}
      confirmLoading={createUser.isPending}
      okText="Add User"
      cancelText="Cancel"
      width={480}
      destroyOnClose
    >
      <Form form={form} layout="vertical" style={{ marginTop: 16 }}>
        <Form.Item
          name="name"
          label="Name"
          rules={[{ required: true, message: 'Name is required' }]}
        >
          <Input placeholder="Full name" />
        </Form.Item>
        <Form.Item
          name="phone"
          label="Phone"
          rules={[{ required: true, message: 'Số điện thoại là bắt buộc' }]}
        >
          <Input placeholder="Số điện thoại" />
        </Form.Item>
        <Form.Item
          name="email"
          label="Email (optional)"
          rules={[
            {
              type: 'email',
              message: 'Invalid email',
            },
          ]}
        >
          <Input type="email" placeholder="email@example.com" />
        </Form.Item>
        <Form.Item
          name="password"
          label="Password"
          rules={[
            { required: true, message: 'Password is required' },
            {
              min: PASSWORD_MIN_LENGTH,
              message: `At least ${PASSWORD_MIN_LENGTH} characters`,
            },
          ]}
        >
          <Input.Password
            placeholder={`Minimum ${PASSWORD_MIN_LENGTH} characters`}
          />
        </Form.Item>
        <Form.Item name="address" label="Address">
          <Input placeholder="Address" />
        </Form.Item>
      </Form>
    </Modal>
  );
}
